export const STANDARD_MSA = {
  MAJOR: 'm',
  SUPPORTING: 's',
  ADDITIONAL: 'a'
};

export const MSA_LABEL_MAPPING = {
  m: 'Major',
  s: 'Supporting',
  a: 'Additional'
};
